if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.resizeTimer = null;
        this.handleResize = this.handleResize.bind(this);
      }

      hide() {
        window.removeEventListener('resize', this.handleResize);
        window.clearTimeout(this.resizeTimer);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        window.removeEventListener('resize', this.handleResize);
        window.addEventListener('resize', this.handleResize);
      }

      handleResize() {
        window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(() => {
          if (!this.hasAttribute('open')) return;

          window.requestAnimationFrame(() => {
            this.showActiveMedia();
          });
        }, 150);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        window.clearTimeout(this.resizeTimer);
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}